export const enum ProjectTypes {
  SSO = 'sso',
  Membership = 'membership',
  PlayerPortals = 'player_portals',
}

export const enum ProjectStylesClass {
  SSO = 'randaSSO',
  Membership = 'randaMembership',
  PlayerPortals = 'randa_player_portals',
}

export const COLOR_WATER_DARK = '#2269AB';
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_PP_INPUT_OUTLINE = '#919EAB';
export const COLOR_DARK_BLUE_PRIMARY = '#06051e';
